import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { createProvider } from './vue-apollo'

import PortalVue from 'portal-vue'
import VueMeta from 'vue-meta'

import CKEditor from '@ckeditor/ckeditor5-vue'
import VueFileAgent from 'vue-file-agent'
import 'vue-file-agent/dist/vue-file-agent.css'
import DatetimePicker from 'vuetify-datetime-picker'

Vue.use(VueMeta)
Vue.use(PortalVue)
Vue.use(CKEditor)
Vue.use(VueFileAgent)
Vue.use(DatetimePicker)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  apolloProvider: createProvider(),
  render: h => h(App)
}).$mount('#app')
